import { ReactComponent as Listen } from 'assets/icons/icon-listen.svg';

export default Listen;
